import type { ReactNode } from 'react';

/**
 * Standard "your CoinMetrics API key doesn't have access to X" message, shown wherever a panel
 * detects (via `detectMetricsMissingFromCatalog`) that the org's key has no catalog access to a
 * metric it depends on — a permission problem, not a "no data" one, so it names what's inaccessible
 * rather than leaving an empty/partial panel the user has no way to explain on their own.
 */
export function buildMissingMetricsErrorMessage(labels: string[]): ReactNode {
  return (
    <>
      Your CoinMetrics API key doesn&apos;t have access to: {labels.join(', ')}.
      <br />
      Contact your administrator to update its permissions.
    </>
  );
}
